import React, { useEffect, useState } from 'react';
import './Styles.css';
import { BankAccountTypes } from '../../../../../Enums/BankAccountType';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import { ServiceClient } from '../../../../../Services/ServiceClient';
import LoaderComponent from '../../../../../Elements/ids/Loader';
import { convertServerDateTime } from '../../../../../Helpers/Converter';
import { PresentationMode } from '../../../../../Enums/PresentationMode';
import ErrorMessage from '../../../../../Elements/ErrorMessage';
import BankAccountLogButtons from './Buttons';
import { createServerErrorMessage } from '../../../../../Helpers/FormInputHelper';
import Modal from '../../../../../Elements/ids/Modal';
import { Ui24Check } from '@ids/react-icons';

const BankAccountLog = ({ agentCode, codePrefix, closeView }) => {
  const [modalMode, setModalMode] = useState(PresentationMode.Loading);
  const [error, setError] = useState(null);
  const [list, setList] = useState([]);

  const isModalOpenedOnTeamLevel = agentCode === null || agentCode === undefined;

  useEffect(() => {
    if (isModalOpenedOnTeamLevel) {
      ServiceClient.getTeamBankAccountLog(
        codePrefix,
        items => {
          setList(items);
          setModalMode(PresentationMode.View);
        },
        error => {
          setModalMode(PresentationMode.Error);
          setError(createServerErrorMessage(error).message);
        }
      );
    } else {
      ServiceClient.getAgentBankAccountLog(
        agentCode,
        items => {
          setList(items);
          setModalMode(PresentationMode.View);
        },
        error => {
          setModalMode(PresentationMode.Error);
          setError(createServerErrorMessage(error).message);
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bankAccountTypeToString = bankAccountType => {
    if (BankAccountTypes.hasValue(bankAccountType)) return BankAccountTypes.keyOf(bankAccountType);
    return <i>{formatMessage(Messages.common_invalid)}</i>;
  };

  return (
    <Modal
      closeView={closeView}
      titleText={`${formatMessage(Messages.bankAccountLog_title, {
        agentCode: agentCode ?? codePrefix,
      })} `}
      buttons={<BankAccountLogButtons closeView={closeView} />}>
      {modalMode === PresentationMode.Loading ? (
        <LoaderComponent />
      ) : modalMode === PresentationMode.Error ? (
        <ErrorMessage message={error} />
      ) : (
        <div className="teamPage-bankLog-container">
          <div
            className={`common-table-row ${
              isModalOpenedOnTeamLevel ? 'teamPage-bankLog-tableRow-team' : 'teamPage-bankLog-tableRow-agent'
            } headerRow`}>
            <div>{formatMessage(Messages.common_bankAccount)}</div>
            <div>{formatMessage(Messages.bankAccountLog_type)}</div>
            <div>{formatMessage(Messages.common_bankName)}</div>
            {!isModalOpenedOnTeamLevel && <div>{formatMessage(Messages.common_inherited)}</div>}
            <div>{formatMessage(Messages.bankAccountLog_updatedAt)}</div>
            <div>{formatMessage(Messages.common_updatedBy)}</div>
          </div>

          {list.map((item, index) => {
            return (
              <div
                className={`common-table-row ${
                  isModalOpenedOnTeamLevel ? 'teamPage-bankLog-tableRow-team' : 'teamPage-bankLog-tableRow-agent'
                } ${index % 2 === 1 ? 'common-modalTable-evenRow' : ''}`}
                key={index}>
                <div>{item.bankAccount?.number}</div>
                <div>{bankAccountTypeToString(item.bankAccount?.type)}</div>
                <div>{item.bankAccount?.bankName}</div>
                {!isModalOpenedOnTeamLevel && <div>{item.inherited ? <Ui24Check /> : null}</div>}
                <div>{convertServerDateTime(item.updated)}</div>
                <div className="teamPage-bankLog-updatedBy">{item.updatedBy}</div>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
};

export default BankAccountLog;
